import { isPlatformServer } from '@angular/common';
import { computed, inject, Injectable, PLATFORM_ID, signal } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';
import { HOSTNAME } from '@app/core/tokens/api.token';

@Injectable({ providedIn: 'root' })
export class DomainResolverService {
  private readonly window = inject(WINDOW);
  private hostName = inject(HOSTNAME, { optional: true });
  isServer = isPlatformServer(inject(PLATFORM_ID));

  getHostname(): string {
    // Server side, use injected hostname token
    if (this.isServer) {
      return this.hostName || '';
    }
    // Cache only in browser
    return this.window?.location?.hostname || '';
  }
}
